import React from 'react';

export const EditIcon = () => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M11.05 3.00002L4.20835 10.2417C3.95002 10.5167 3.70002 11.0584 3.65002 11.4334L3.34169 14.1334C3.23335 15.1084 3.93335 15.775 4.90002 15.6084L7.58335 15.15C7.95835 15.0834 8.48335 14.8084 8.74168 14.525L15.5834 7.28335C16.7667 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2334 1.75002 11.05 3.00002Z'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9.90833 4.20703C10.2667 6.50703 12.1333 8.26536 14.45 8.4987'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M2.5 18.332H17.5'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export const NewEditIcon = () => {
    return (
        <svg
            width='21'
            height='20'
            viewBox='0 0 21 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9.66699 1.66663H8.00033C3.83366 1.66663 2.16699 3.33329 2.16699 7.49996V12.5C2.16699 16.6666 3.83366 18.3333 8.00033 18.3333H13.0003C17.167 18.3333 18.8337 16.6666 18.8337 12.5V10.8333'
                stroke='#00516A'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.8666 2.51663L7.2999 9.0833C7.0499 9.3333 6.7999 9.82497 6.7499 10.1833L6.39157 12.6916C6.25823 13.6 6.8999 14.2333 7.80823 14.1083L10.3166 13.75C10.6666 13.7 11.1582 13.45 11.4166 13.2L17.9832 6.6333C19.1166 5.49997 19.6499 4.1833 17.9832 2.51663C16.3166 0.849966 14.9999 1.3833 13.8666 2.51663Z'
                stroke='#00516A'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.9248 3.45837C13.4831 5.45004 15.0415 7.00837 17.0415 7.57504'
                stroke='#00516A'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};
